import React from 'react';
import { Send, FileText } from 'lucide-react';

const NotificationTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-1 inline-flex gap-2">
      <button
        onClick={() => onTabChange('notifications')}
        className={`flex items-center gap-2 px-6 py-2.5 rounded-lg font-medium transition-all ${
          activeTab === 'notifications'
            ? 'bg-[#FF6B00] text-white shadow-md'
            : 'text-gray-700 hover:bg-gray-50'
        }`}
      >
        <Send className="w-4 h-4" />
        Notifications
      </button>
      <button
        onClick={() => onTabChange('templates')}
        className={`flex items-center gap-2 px-6 py-2.5 rounded-lg font-medium transition-all ${
          activeTab === 'templates'
            ? 'bg-[#FF6B00] text-white shadow-md'
            : 'text-gray-700 hover:bg-gray-50'
        }`}
      >
        <FileText className="w-4 h-4" />
        Modèles
      </button>
    </div>
  );
};

export default NotificationTabs;
